import React from 'react';

import { Input as ChakraInput, useSlotRecipe } from '@chakra-ui/react';

import { IconsLinear } from '@nocowanie/icons';

import { SearchLocationProps } from './search-location.props';

import { defaultSearchLocationTranslation } from '../../../models';
import { Autocomplete } from '../autocomplete';
import { AutocompleteBaseItemModel } from '../autocomplete/autocomplete-base-item.model';

export const SearchLocation = <T extends AutocompleteBaseItemModel>({
    ref,
    autocompleteData,
    inputProps = {},
    translationData = defaultSearchLocationTranslation,
    ...rest
}: SearchLocationProps<T> & {
    ref?: React.ForwardedRef<typeof ChakraInput>;
}): React.ReactNode => {
    const recipe = useSlotRecipe({
        key: 'searchLocation',
    });
    const styles = recipe();
    const { ref: inputRef, inputProps: innerInputProps, ...props } = inputProps;

    return (
        <Autocomplete
            {...autocompleteData}
            inputProps={{
                leftIcon: <IconsLinear.Location size={'sm'} {...styles.icon} />,
                ref: inputRef,
                ...props,
                inputProps: {
                    placeholder: translationData.locationPlaceholder,
                    ...innerInputProps,
                },
            }}
            {...rest}
        />
    );
};
